import React from 'react';

import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Rating from '@material-ui/lab/Rating';
import { FlexContainer, StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const COLORS = {
  red: theme.palette.error.dark,
  orange: theme.palette.warning.dark,
  green: theme.palette.green.medium,
  grey: theme.palette.borders.lighterGrey,
};

const StyledRating = withStyles({
  iconEmpty: {
    color: COLORS.grey,
  },
  icon: {
    marginRight: '6px',
  },
})(Rating);

export const Score = ({ scale, score, color, justify = 'center' }) => {
  const roundOffScale = Math.round(scale);
  const roundOffScore = Math.round(score);
  return (
    <FlexContainer style={{ justifyContent: justify === 'right' ? 'flex-end' : justify }}>
      <StyledRating
        style={{ color: COLORS[color] }}
        defaultValue={roundOffScore}
        max={roundOffScale}
        icon={<FiberManualRecordIcon fontSize="small" />}
        readOnly
      />
      <Box pt={3}>
        <StyledTypography display="inline" customColor={COLORS[color]} leftGutter={1.25} variant="body2">
          <b>{score}</b>/{roundOffScale}
        </StyledTypography>
      </Box>
    </FlexContainer>
  );
};

export default Score;
